import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PhotosService {

    constructor() { }

    facebookPost = [
        {
            id: 1,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-post%2Fone%2FBusiness%20Webinar.png?alt=media&token=c07dc61b-e1b5-4b2b-981c-8a95baba0d5c"
        },
        {
            id: 2,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-post%2Fone%2FExplore%20the%20Island.png?alt=media&token=efecd1dd-12d1-4c4d-b091-848541913525"
        },
        {
            id: 3,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-post%2Fone%2FLorem%20ipsum%20dolor%20sit%20amet%2C%20consectetur%20adipiscing%20elit.%20Mauris%20nisi%20sapien%2C%20bibendum%20id%20ante%20quis%2C%20maximus%20euismod%20ligula.%20Proin%20nisi%20dui%2C%20feugiat%20sodales%20bibendum%20at.png?alt=media&token=637acf8b-2ac7-457f-8226-6d3e40fcb71e"
        },
        // {
        //     id: 4,
        //     title:"",
        //     url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-post%2Fone%2FSPECIAL%20FOOD.png?alt=media&token=90193c7a-6b0f-41a2-8b00-1fc84014c80e"
        // },
        // {
        //     id: 5,
        //     title:"",
        //     url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-post%2Fone%2FSPECIAL%20FOOD1.png?alt=media&token=a7e07302-2845-4ebe-a08e-55f8b147821d"
        // },
        {
            id: 6,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-post%2Fone%2FSPECIAL%20FOOD11.png?alt=media&token=a4416308-791a-487e-8cf0-399323fdec46"
        },
        {
            id: 7,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-post%2Fone%2FSPECIAL%20FOOD2.png?alt=media&token=b495bd0e-2885-4f7a-bb86-3de4556233f2"
        },
        // {
        //     id: 8,
        //     title:"",
        //     url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-post%2Fone%2FSPECIAL%20FOOD4.png?alt=media&token=b7ab30a8-c2b1-4a1f-b44e-c4c0127ac730"
        // },
        // {
        //     id: 9,
        //     title:"",
        //     url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-post%2Fone%2FSPECIAL%20FOOD7.png?alt=media&token=3d3ecd21-4cae-4b34-b0da-bb6e8d9347aa"
        // },
        // {
        //     id: 10,
        //     title:"",
        //     url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-post%2Fone%2FSPECIAL%20FOOD8.png?alt=media&token=cd3c8f15-5693-4274-a047-c46812684175"
        // },
        {
            id: 11,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-post%2Fone%2FSPECIAL%20FOOD9.png?alt=media&token=182b67de-79e9-48b5-b7a7-2a045aecb176"
        },
        {
            id: 12,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-post%2Fone%2FSPECIAL%20FOODd.png?alt=media&token=35528013-e901-4c89-b3f2-d2d20a9c976d"
        },
        // {
        //     id: 13,
        //     title:"",
        //     url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-post%2Fone%2FSUMMER%20SALE.png?alt=media&token=8a21b46f-0312-4a32-92b6-244c0555a63b"
        // },
        {
            id: 14,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-post%2Fone%2FSUMMER%20SwALE.png?alt=media&token=f1936589-5995-40f4-af2f-78ffbc36916f"
        },
        {
            id: 15,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-post%2Fone%2FSUMMERd%20SALE.png?alt=media&token=35f30efe-4a98-41ba-aadc-4a92c42f1430"
        },
        {
            id: 16,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-post%2Fone%2FSUeMMER%20SALE.png?alt=media&token=a2eaad57-5abd-4f36-b475-667f0849946a"
        },
        {
            id: 17,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-post%2Fone%2FTravel.png?alt=media&token=84937846-ecfc-44fd-87fc-e81f1aff6fe9"
        },
        {
            id: 18,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-post%2Fone%2FUntitled%20design.png?alt=media&token=9e0da182-d87a-48f0-a0a2-a0558f6e6015"
        },
        {
            id: 19,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-post%2Fone%2FUntitled%20design2.png?alt=media&token=affb93d5-5e78-4dfd-bbba-5196db869d72"
        },
        {
            id: 20,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-post%2Fone%2Fsummer.png?alt=media&token=b413dce8-b911-44f0-87b0-dd7673053f44"
        },
        {
            id: 21,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-post%2Fone%2Fsummer2.png?alt=media&token=d46ea881-4fa6-4561-bcfd-4547bd7fa15e"
        },
        {
            id: 22,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-post%2Fone%2Fwww.reallygreatsite.com.png?alt=media&token=81635963-2ee7-4ef9-8320-cf6c4d7c6579"
        },
        {
            id: 23,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-post%2Fone%2Fwww.reallygreatsite.comgg.png?alt=media&token=62797a7d-24bc-45a5-8083-f71ae9c6bb83"
        },
        {
            id: 24,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-post%2Fone%2Fwww.reallygreatsite.comss.png?alt=media&token=2f8d3465-9457-4ec1-889b-266379a0764d"
        },
        // {
        //     id: 25,
        //     title:"",
        //     url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-post%2Fone%2Fwww.reallygreatsite.comw.png?alt=media&token=b1fe5e22-a8e0-4708-8762-4f294ff23d4e"
        // },
    ];

    instagramPost = [
        {
            id: 1,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagram-post%2Fone%2FBlue%20and%20White%20Minimalist%20Tour%20Agency%20Instagram%20Post.png?alt=media&token=afbd2989-389f-4d08-b923-fbd1ffe24ea7"
        },
        {
            id: 13,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagram-post%2Fone%2FRed%20and%20Gold%20%20Aesthetic%20%20Discount%20Happy%20Lunar%20Chinese%20New%20Year%20Instagram%20Post.png?alt=media&token=7310ff83-d329-4b93-8476-f0af9713d3d7"
        },
        {
            id: 14,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagram-post%2Fone%2FTake%20a%20look%20at%20my%20Canva%20design!(1).png?alt=media&token=2fb6fd19-6718-4dc4-b3f3-9cda41d3fece"
        },
        {
            id: 15,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagram-post%2Fone%2FTake%20a%20look%20at%20my%20Canva%20design!.png?alt=media&token=7a16a3b3-c378-4f76-9c66-98647092d876"
        },
        {
            id: 16,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagram-post%2Fone%2FUntitled%20desiegn.png?alt=media&token=6e0b49cd-6631-4508-90db-ac194f594da0"
        },
        {
            id: 17,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagram-post%2Fone%2FWhite%20Prevent%20Coronavirus%20Instagram%20Post.png?alt=media&token=4d4036c1-4ec8-4de7-85c3-8884c08fb02e"
        },
        {
            id: 4,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagram-post%2Fone%2FBlue%20And%20White%20Minimalist%20Time%20To%20Travel%20Instagram%20Post.png?alt=media&token=9e0a6a1d-0f66-419d-b4db-cdc251c28896"
        },
        {
            id: 5,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagram-post%2Fone%2FBlue%20And%20Yellow%20Let_s%20Travel%20Instagram%20Post.png?alt=media&token=22741ac3-30ca-4c00-80b0-9a2017e9785b"
        },
        {
            id: 6,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagram-post%2Fone%2FBlue%20Explore%20Your%20Dream%20Places%20Travel%20Sale%20Instagram%20Post.png?alt=media&token=7fa5cf39-966a-4308-a900-bb20b841a3f7"
        },
        {
            id: 7,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagram-post%2Fone%2FBlue%20Modern%20Travel%20Guide%20To%20Do%20In%20Macau%20Instagram%20Post.png?alt=media&token=dd364cfc-fdb2-449f-ae16-4b6ab0ebea66"
        },
        {
            id: 8,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagram-post%2Fone%2FBlue%20White%20Illustartion%20Winter%20Instagram%20Post.png?alt=media&token=1d348de8-7868-4db8-aaa1-1aaab6ffdc39"
        },
        {
            id: 9,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagram-post%2Fone%2FBone%20Orange%20This%20or%20That%20Your%20Favourite%20Spaghetti%20Instagram%20Post.png?alt=media&token=2e79220f-4d0d-46f7-b933-8c6bc2737d00"
        },
        {
            id: 10,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagram-post%2Fone%2FOrange%20Simple%20Minimalist%20Silhouette%20International%20Yoga%20Day%20Instagram%20Post.png?alt=media&token=a8a6ede4-1f9e-497b-a59a-0d69f77d1c21"
        },
        {
            id: 11,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagram-post%2Fone%2FOrange%20Work%20From%20Home%20Illustration%20Instagram%20Post_.png?alt=media&token=d08818d0-20a7-424f-b548-f0d01c0dedc2"
        },
        {
            id: 12,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagram-post%2Fone%2FPet%20Shop%20(Instagram%20Post).png?alt=media&token=0a0162d8-0ab9-4948-9f45-e0bf65a48706"
        },
        {
            id: 2,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagram-post%2Fone%2FBiru%20Hijau%20Illustrasi%20Ajakan%20menjadi%20Relawan%20Covid%20Konten%20Instagram.png?alt=media&token=1048fd7c-4e03-4764-a731-17373235ce21"
        },
        {
            id: 3,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagram-post%2Fone%2FBiru%20Hijau%20Illustrasi%20Pertanyaan%20Singkat%20Konten%20Instagram.png?alt=media&token=058e35bf-ecb7-4f69-bb88-f75de2d583cb"
        },
        {
            id: 18,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagram-post%2Fone%2FYellow%20Modern%20Food%20Promotion%20Design%20(Instagram%20Post).png?alt=media&token=747495ec-74ce-453d-af7a-d78561aba29a"
        },
        {
            id: 19,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagram-post%2Fone%2FYellow%20Orange%20Delivery%20Instagram%20Post.png?alt=media&token=0e88e64e-6051-42e8-b799-fd98b987e98b"
        },
        {
            id: 20,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagram-post%2Fone%2FYellow%20and%20Black%20Travel%20Destination%20Explore%20The%20World%20Instagram%20Post.png?alt=media&token=241b9d09-0eca-4b84-9d81-cd84ad18acad"
        },
        {
            id: 21,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagram-post%2Fone%2FYellow%20and%20White%20Aesthetic%20Kids%20Moments%20Instagram%20Post.png?alt=media&token=1ba494e1-5e62-4707-b510-c8a4f316464a"
        },
        {
            id: 22,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagram-post%2Fone%2Fwww.dropoutcodncept.com.png?alt=media&token=94f376e3-4130-4ca2-9a27-32eb279104e1"
        },
        {
            id: 23,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagram-post%2Fone%2Fwww.dropoutconcept.com.png?alt=media&token=1bd3a395-43bb-45f2-94af-f62427c82c53"
        },
        {
            id: 24,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagram-post%2Fone%2Fwww.dropoutssconcept.com.png?alt=media&token=5618b51a-8ad9-4e46-8a10-9deeca8649a9"
        }
    ];

    instagramStory = [
        {
            id: 1,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagrap-story%2Fone%2FBest%20Medical%20Service%20%20(Instagram%20Story)(1).png?alt=media&token=ee6ec1b4-e5eb-4462-aa30-7f61041f03ac"
        },
        {
            id: 2,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagrap-story%2Fone%2FBest%20Medical%20Service%20%20(Instagram%20Story).png?alt=media&token=c3cac82e-55d2-45f9-97f4-489cf9227a36"
        },
        {
            id: 3,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagrap-story%2Fone%2FBlack%20Modern%20Good%20Morning%20(Instagram%20Story).png?alt=media&token=d1212fb1-1c79-4c20-9820-08a5c67d974b"
        },
        {
            id: 4,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagrap-story%2Fone%2FBlack%20_%20Yellow%20Special%20Menu%20Instagram%20Story.png?alt=media&token=99783b98-51f6-46c2-8395-d73c5c2b2cc4"
        },
        {
            id: 5,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagrap-story%2Fone%2FBlue%20Bronze%20Modern%20Luxury%20Summer%20Holiday%20Promo%20Discount%20Instagram%20Story.png?alt=media&token=97bcb69a-ab0e-46d6-8f30-cada66011308"
        },
        {
            id: 6,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagrap-story%2Fone%2FBlue%20Modern%20Travel%20(Instagram%20Story).png?alt=media&token=05fdbbe2-5f05-42b4-aad8-30dd0aa1ebb6"
        },
        {
            id: 7,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagrap-story%2Fone%2FBlue%20Orange%20Minimalist%20Promotion%20Furniture%20Your%20Story.png?alt=media&token=d1d84d0c-33be-498b-81f9-671395df26e0"
        },
        {
            id: 8,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagrap-story%2Fone%2FBlue%20The%20Marchesi%20Hotel%20Instagram%20Story.png?alt=media&token=29c75c0a-b20d-4331-b610-22a632cbc219"
        },
        {
            id: 9,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagrap-story%2Fone%2FBlue%20and%20white%20minimalist%20hotel%20and%20resort%20(Instagram%20Story).png?alt=media&token=1d3dfbbb-a2a6-4ad3-9ac8-b0b8560017d1"
        },
        {
            id: 10,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagrap-story%2Fone%2FBorcelle%20Luxury%20Hotel%20(Instagram%20Story).png?alt=media&token=5f8d2e0e-9642-4d7d-ba32-bb226b10dfcd"
        },
        {
            id: 11,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagrap-story%2Fone%2FBrown%20Modern%20Travel%20(Instagram%20Story).png?alt=media&token=062fcd11-c4a9-48d9-8a75-78ce8143b0cc"
        },
        {
            id: 12,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagrap-story%2Fone%2FFauget%20Hotel%20(Instagram%20Story).png?alt=media&token=219989bf-579e-4a1f-b023-e4a7f9a5888d"
        },
        // {
        //     id: 13,
        //     title:"",
        //     url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagrap-story%2Fone%2FFood%20Promotion%20(Instagram%20Story).png?alt=media&token=3f95de96-bcf9-4cf9-a13d-204b68867a73"
        // },
        {
            id: 14,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagrap-story%2Fone%2FGreen%20Aesthetic%20Welcome%20April%20Instangram%20Story.png?alt=media&token=0defd272-b295-4f0c-a893-416b09d125b9"
        },
        {
            id: 15,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagrap-story%2Fone%2FGreen%20White%20Minimalist%20Tour%20Travel%20Instagram%20Story.png?alt=media&token=26910bea-1108-4955-ac7b-a7304d45274a"
        },
        {
            id: 16,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagrap-story%2Fone%2FGreen%20_%20Black%20Trendy%20Feminine%20Aesthetic%20Frame%20Collage%20Instagram%20Story.png?alt=media&token=fbd9e599-0942-418a-b8f2-62c864272a29"
        },
        {
            id: 17,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagrap-story%2Fone%2FGreen%20_%20Yellow%20Minimalist%20Hotel%20Instagram%20Story.png?alt=media&token=dabf9cca-6e76-4c79-bcd5-5c0831a16472"
        },
        {
            id: 18,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagrap-story%2Fone%2FHappy%20Summer%20(Instagram%20Story).png?alt=media&token=3298a153-cf51-442e-8830-4a9e629cbb9f"
        },
        {
            id: 19,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagrap-story%2Fone%2FPhotos%20Collage%20free%20template%2C%20traveller%20template%20Instagram%20Story.png?alt=media&token=72c2a3f8-7e1a-4574-bfbe-146d7b78f26d"
        },
        {
            id: 20,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagrap-story%2Fone%2FSpecial%20Pizza%20(Instagram%20Story).png?alt=media&token=ce00eb2e-3680-420f-b222-04427430ae7e"
        },
        {
            id: 21,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagrap-story%2Fone%2FWhite%20Minimalist%20Happy%20Mother%20Days%20Photo%20Collage%20Instagram%20Story.png?alt=media&token=c43803f0-0f63-4e20-922f-ff5b8e7b5888"
        },
        {
            id: 22,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagrap-story%2Fone%2FWhite%20and%20brown%20minimalist%20hotel%20and%20resort%20(Instagram%20Story).png?alt=media&token=eb6e0098-f1f0-4e57-ac54-251b81de9e12"
        },
        // {
        //     id: 23,
        //     title:"",
        //     url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Finstagrap-story%2Fone%2FYellow%20Aesthetic%20Birthday%20Instagram%20Story.png?alt=media&token=ed93d093-101b-4bd2-ab15-c6946c3603d0"
        // },
        // {
        //     id: 24,
        //     title:"",
        //     url:""
        // },
        // {
        //     id: 25,
        //     title:"",
        //     url:""
        // },
    ];

    appUi = [
        {
            id: 2,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fapp-ui%2Fone%2F298610545_105686275585651_8735824679611502146_n.jpeg?alt=media&token=a3fd7dd7-6cd9-49e9-a648-13925f4886e4"
        },
        {
            id: 1,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fapp-ui%2Fone%2F298578369_105686272252318_3502387491185495343_n.jpeg?alt=media&token=5d1fdf01-5263-49c4-bf24-e1db9c034447"
        },
        {
            id: 3,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fapp-ui%2Fone%2F298655832_105686292252316_7800919064457691278_n.png?alt=media&token=2505da18-14ce-4864-a24c-dd665dcdb051"
        },
        {
            id: 4,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fapp-ui%2Fone%2F298735077_105686305585648_9131390115917587680_n.png?alt=media&token=1c8bb580-3bb1-4320-aa54-5e4269901670"
        },
        {
            id: 5,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fapp-ui%2Fone%2F298750884_105686298918982_984471281766839377_n.jpeg?alt=media&token=95e7b2c0-e5ef-429d-b69e-fa08469ff0af"
        },
        {
            id: 5,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fapp-ui%2Fone%2F298787072_105686255585653_8964034348802216379_n.jpeg?alt=media&token=7284ac33-518e-43b9-8b94-96f726905b2c"
        }
    ];

    websiteUi = [
        {
            id: 1,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fweb-ui%2Fone%2F298541740_105741318913480_6213802022422137565_n.jpeg?alt=media&token=5cf0cd71-dc7b-4a7b-91b2-62b0cc4e1f4f"
        },
        {
            id: 2,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fweb-ui%2Fone%2F298641280_105741472246798_4516923173001778561_n.jpeg?alt=media&token=c67dab45-58a2-481a-84a5-78ad50972b7c"
        },
        {
            id: 3,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fweb-ui%2Fone%2F298793445_105741245580154_79578407480829986_n.png?alt=media&token=08385396-6023-4d5d-b85c-c92f195204fa"
        },
        {
            id: 4,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fweb-ui%2Fone%2F298913712_105741492246796_4287565749628570258_n.jpeg?alt=media&token=565c96e4-1455-4ca1-ae31-60f71def7dd7"
        },
        {
            id: 5,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fweb-ui%2Fone%2F298977944_105741462246799_6615883884517455250_n.jpeg?alt=media&token=41ae8f2c-1c70-4a9d-807a-24ea467ebc0b"
        },
        {
            id: 6,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fweb-ui%2Fone%2F298944734_105741275580151_3074310645281880653_n.jpeg?alt=media&token=291244df-8b47-4ac6-9fbe-8b482656d9f0"
        },
        {
            id: 7,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fweb-ui%2Fone%2F298832888_105741122246833_73032000947387970_n.jpeg?alt=media&token=b39c9c68-059c-49ba-8864-f693d7f11913"
        },
        {
            id: 8,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fweb-ui%2Fone%2F298831156_105741195580159_8605119186192394707_n.jpeg?alt=media&token=b4b487f6-9db2-46a1-b9e1-ecce78f05a6f"
        },
        {
            id: 9,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fweb-ui%2Fone%2F298796908_105741142246831_396433589229012632_n.jpeg?alt=media&token=4b3b7a50-0d04-4d6a-8a6d-43680f036a36"
        },
        {
            id: 10,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fweb-ui%2Fone%2F298775194_105741145580164_8678891760668385565_n.jpeg?alt=media&token=d9efa817-fa87-4279-aa8d-1d928b5b1fa9"
        },
        {
            id: 11,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fweb-ui%2Fone%2F298743311_105741415580137_4706228620947750344_n.jpeg?alt=media&token=553c394d-4f47-4c5b-96bb-54984ed5774f"
        },
        {
            id: 12,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fweb-ui%2Fone%2F298740009_105741398913472_4001428579321950074_n.jpeg?alt=media&token=c5566d99-81cc-4e43-9639-a920764814cc"
        },
        {
            id: 13,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fweb-ui%2Fone%2F298571253_105741372246808_9055161799640414761_n.jpeg?alt=media&token=1939e241-5d0c-439a-bd3e-db88b11d790e"
        },
        {
            id: 14,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fweb-ui%2Fone%2F298571155_105741162246829_3738350300887494779_n.jpeg?alt=media&token=eae8583c-b751-461c-b1ec-0e891ea6e84d"
        },
        {
            id: 15,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fweb-ui%2Fone%2F298564282_105741262246819_2307303404914216525_n.jpeg?alt=media&token=10a62e96-4cac-44ac-960c-36783c795013"
        },
        {
            id: 16,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fweb-ui%2Fone%2F298543914_105741322246813_1735914125806184778_n.jpeg?alt=media&token=27453f08-4a29-4e22-ac8e-f79a52b67994"
        },
    ];

    facebookCover = [
        {
            id: 1,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-cover%2Fone%2FBlack%20_%20Yellow%20Digital%20Marketing%20Facebook%20Cover.png?alt=media&token=77f8cea1-87da-4db6-8c1b-24331d47f069"
        },
        {
            id: 2,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-cover%2Fone%2FBlue%20Gradient%20Medical%20Consultation%20Facebook%20Cover.png?alt=media&token=52b49fa6-f888-454b-ac77-86a50449eefc"
        },
        {
            id: 3,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-cover%2Fone%2FBlue%20_%20Yellow%20Fashion%20Sale%20Facebook%20Cover.png?alt=media&token=ace900d9-d7f0-44ff-9cc5-410c95c01fbd"
        },
        {
            id: 4,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-cover%2Fone%2FBlue%20and%20Yellow%20Simple%20Digital%20Marketing%20(Facebook%20Cover).png?alt=media&token=14fb9a0a-e11e-44a2-9b94-27a92f8c434d"
        },
        {
            id: 5,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-cover%2Fone%2F0001-33112728697.png?alt=media&token=5cd009c3-92e0-47b5-a622-34e43934d895"
        },
        {
            id: 6,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-cover%2Fone%2FColorful%20Photo%20Collage%20Kids%20Summer%20Camp%20Facebook%20Cover.png?alt=media&token=373c0ea1-062f-4de9-9d03-809249bc6f6c"
        },
        {
            id: 7,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-cover%2Fone%2FGinger%20Sunny%20Just%20Living%20Photo%20Collage%20Facebook%20Cover.png?alt=media&token=b7f09162-01b3-4ead-b391-e8cb6cede736"
        },
        {
            id: 8,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-cover%2Fone%2FGreen%20and%20Brown%20Cosmetics%20Beauty%20Store%20Photo%20Collage%20Facebook%20Cover.png?alt=media&token=dddc8b04-89f2-4999-9a82-9a0ee441122d"
        },
        {
            id: 9,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-cover%2Fone%2FModern%20Design%20Colsultation%20Promotion%20Facebook%20Cover.png?alt=media&token=0630b3a9-6b43-4072-bc9e-1ff8194224f4"
        },
        {
            id: 10,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-cover%2Fone%2FOrange%20_%20White%20Minimalist%20Digital%20Marketing%20Facebook%20Cover.png?alt=media&token=c0418585-8e13-42b7-abe5-0a5a1b988ab0"
        },
        {
            id: 11,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-cover%2Fone%2FPink%20Modern%20Happy%20Birthday%20Facebook%20Cover.png?alt=media&token=40f45ce3-8e63-4a97-a6ef-1d3e1a7fc4ee"
        },
        {
            id: 12,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-cover%2Fone%2FSolid%20Blue%20Minimalist%20Shopping%20Bag%20Spring%20Concept%20Photo%20Facebook%20Cover.png?alt=media&token=851199b3-92bd-4cde-ad1a-4776e8c71bc2"
        },
        {
            id: 13,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-cover%2Fone%2FSummer%20Vibes%20Photo%20Collage%20Facebook%20Cover.png?alt=media&token=a0430c3d-f1c1-418d-abed-ce5be7569df5"
        },
        {
            id: 14,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-cover%2Fone%2FWhite%20Social%20Media%20Digital%20Marketing%20Facebook%20Cover.png?alt=media&token=01773c95-8054-45dc-9c20-a958bc8a76ab"
        },
        {
            id: 15,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-cover%2Fone%2Fdark%20green%20white%20minimalist%20furniture%20sale%20facebook%20cover.png?alt=media&token=31577ceb-c7c1-44c8-9425-83e768ae3979"
        },
        // {
        //     id: 16,
        //     title:"",
        //     url:""
        // },
    ];

    facebookAd = [
        {
            id: 1,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-ad%2Fone%2FBlue%20and%20White%20Digital%20Creative%20Agency%20Facebook%20Ad.png?alt=media&token=043ea4a4-8f1d-49d1-a90e-b78ae3859b5f"
        },
        {
            id: 2,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-ad%2Fone%2FBlue%20Minimalist%20Headphone%20Sale%20Facebook%20Ad.png?alt=media&token=b9e71301-94fb-4ecb-8deb-0c8454e91052"
        },
        {
            id: 3,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-ad%2Fone%2FBrown%20Minimalist%20Luxury%20Real%20Estate%20Open%20House%20Facebook%20Ad.png?alt=media&token=a131ac39-6fc9-48d4-82ec-bd08fce88297"
        },
        {
            id: 4,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-ad%2Fone%2FColorful%20Minimalist%20Phone%20Sale%20Facebook%20Ad.png?alt=media&token=236fb10e-f48c-47d8-8122-9de3da57456d"
        },
        {
            id: 5,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-ad%2Fone%2FGrey%20Black%20Furniture%20Sale%20facebook%20ad.png?alt=media&token=d54b9a85-b649-4724-96a5-883046d03681"
        },
        {
            id: 6,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-ad%2Fone%2FOrange%20And%20Black%20Modern%20Special%20Sale%20Outerwear%20Facebook%20Ad.png?alt=media&token=b6c3a387-2894-4d99-bb07-db102a4707e2"
        },
        // {
        //     id: 7,
        //     title:"",
        //     url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-ad%2Fone%2FOrange%20modern%20fried%20chicken%20banner%20facebook%20ad.png?alt=media&token=8d2e4c71-177a-4f20-b928-b707438ca5b1"
        // },
        {
            id: 8,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-ad%2Fone%2FPurple%20And%20White%20Modern%203D%20Illustration%20Improve%20Brand%20Awareness%20Facebook%20Ad.png?alt=media&token=8933d717-4e09-4282-a091-73d9e0cc2986"
        },
        {
            id: 9,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-ad%2Fone%2FPurple%20And%20White%20Modern%203D%20Illustration%20SEO%20Strategies%20Facebook%20Ad.png?alt=media&token=9c8e9ba8-e1d6-48e6-ac1f-46d48bc71958"
        },
        {
            id: 10,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-ad%2Fone%2FWe%20Are%20LookIng%20For%20You%20Facebook%20Ad.png?alt=media&token=c5dea5bf-3863-4eca-a468-de51812893a6"
        },
        {
            id: 11,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-ad%2Fone%2FWhite%20Blue%20Minimalist%20Modern%20Facebook%20Ad.png?alt=media&token=9de87088-0b79-4b61-bbdb-bd0b68d93bc9"
        },
        {
            id: 12,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Ffacebook-ad%2Fone%2FWhite%20Modern%20Real%20Estate%20For%20Sale%20Facebook%20Ad.png?alt=media&token=ad31d7eb-ca61-4a69-b0b7-86446d4ed1ad"
        },
        // {
        //     id: 13,
        //     title:"",
        //     url:""
        // },
        // {
        //     id: 14,
        //     title:"",
        //     url:""
        // },
        // {
        //     id: 15,
        //     title:"",
        //     url:""
        // },
        // {
        //     id: 16,
        //     title:"",
        //     url:""
        // },
    ];

    etsyBanners = [
        {
            id: 1,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fetsy-banner%2F10.png?alt=media&token=d8f7ccfb-e795-4e2e-a941-db21bb519ccb"
        },
        {
            id: 2,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fetsy-banner%2F11.png?alt=media&token=4e5d4a13-d420-443d-80a6-a60a9075197e"
        },
        {
            id: 3,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fetsy-banner%2F12.png?alt=media&token=ead1a2f9-6db0-40b0-a5fe-20f8d0f69034"
        },
        {
            id: 4,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fetsy-banner%2F13.png?alt=media&token=6d6b789e-70cf-4c8f-ac38-23d7cf126d5f"
        },
        {
            id: 5,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fetsy-banner%2F14.png?alt=media&token=893c0f22-cba8-4174-b157-aa9cda8ea525"
        },
        {
            id: 6,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fetsy-banner%2F2.PNG?alt=media&token=20b9104f-5906-4e41-ad27-6657806fa623"
        },
        {
            id: 7,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fetsy-banner%2F3.PNG?alt=media&token=efc5c52e-0471-492f-a369-d339509d2562"
        },
        {
            id: 8,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fetsy-banner%2F4.PNG?alt=media&token=aa8b895b-9c6b-4f93-9305-bb5a34822ff5"
        },
        {
            id: 9,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fetsy-banner%2F5.PNG?alt=media&token=58096a67-d14c-43f2-b619-7d04eb7da351"
        },
        {
            id: 10,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fetsy-banner%2F6.PNG?alt=media&token=1f128139-5a35-4a95-bf03-6d31cf49ab3f"
        },
        {
            id: 11,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fetsy-banner%2F7.PNG?alt=media&token=fbeee305-7f4d-4933-9216-f1622dd6da1f"
        },
        {
            id: 12,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fetsy-banner%2F8.png?alt=media&token=0a4d4f25-8288-4fff-bf60-4913069005b3"
        },
        {
            id: 13,
            title:"",
            url:"https://firebasestorage.googleapis.com/v0/b/iamsharma.appspot.com/o/photos%2Fetsy-banner%2F9.png?alt=media&token=d917159e-817f-4370-a31d-2f8d96d94380"
        },
    ];
}
